package com.evoapps.evoshift.domain.usecase.availability

import com.evoapps.evoshift.domain.model.Availability
import com.evoapps.evoshift.domain.model.WeeklyAvailabilityTemplate
import kotlinx.datetime.DatePeriod
import kotlinx.datetime.LocalDate
import kotlinx.datetime.isoDayNumber
import kotlinx.datetime.minus

class ApplyWeeklyAvailabilityTemplateUseCase {
    operator fun invoke(
        template: WeeklyAvailabilityTemplate,
        targetAvailability: Availability,
        year: Int,
        month: Int
    ): Availability {
        val updatedDays = targetAvailability.days.toMutableMap()

        // Days in month logic
        val firstDayOfNextMonth = if (month == 12) {
            LocalDate(year + 1, 1, 1)
        } else {
            LocalDate(year, month + 1, 1)
        }
        val lastDayOfCurrentMonth = firstDayOfNextMonth.minus(DatePeriod(days = 1))

        for (day in 1..lastDayOfCurrentMonth.day) {
            val date = LocalDate(year, month, day)
            val dayOfWeek = date.dayOfWeek.isoDayNumber // 1..7

            val templatePreference = template.days[dayOfWeek]
            if (templatePreference != null) {
                updatedDays[day] = templatePreference
            }
        }

        return targetAvailability.copy(days = updatedDays, isFilled = true)
    }
}
